import { createFileRoute } from '@tanstack/react-router'
import { ProfileTab } from '@/pages/Settings'

export const Route = createFileRoute('/_authenticated/settings/profile')({
  component: ProfileTab,
})
